// extracted by mini-css-extract-plugin
export var formCard = "luas-next-trams-block-module--formCard--3269c";
export var icon = "luas-next-trams-block-module--icon--69c87";
export var iconContainer = "luas-next-trams-block-module--iconContainer--ac077";
export var searchButton = "luas-next-trams-block-module--searchButton--58975";